import { useEffect, useRef } from 'react'
import { emitReboot } from '@/utils/app'

const currentVersion = '' + import.meta.env.VITE_CLIENT_VERSION
const timeout = +import.meta.env.VITE_UPDATE_VERSION_TIMEOUT || 60000

const useCheckVersion = () => {
  const timer = useRef<NodeJS.Timeout>(undefined)
  const loading = useRef(false)

  useEffect(() => {
    timer.current = setInterval(async() => {
      if (loading.current) {
        return
      }
      loading.current = true
      try {
        const response = await fetch('/', {
          cache: 'reload'
        })
        if (!response.ok) {
          throw new Error('Could not reload the page')
        }
        const html = await response.text()
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')
        const metaVersion = doc.documentElement.querySelector('meta[name="version"]')
        if (!metaVersion) {
          throw new Error('No matching tag')
        }
        const version = metaVersion.getAttribute('content')
        if (version !== currentVersion) {
          clearInterval(timer.current)
          emitReboot()
        }
      } finally {
        loading.current = false
      }
    }, timeout)

    return () => {
      clearInterval(timer.current)
    }
  }, [])
}

export default useCheckVersion
